import { timelineSteps } from "@/mocks/media";

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,380px)_1fr]">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-primary-500" />
              <span className="text-xs font-medium uppercase tracking-[0.25em] text-primary-500">
                BATTLE TIMELINE
              </span>
            </div>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              一场危机的
              <br />
              攻防时间线
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
              从爆料发酵到舆情回落，我们把它拆成七个可追踪的阶段。每个阶段做对与做错，都会直接影响最终走向。
            </p>
            <div className="mt-6 rounded-lg border-l-4 border-accent-500 bg-accent-50 p-4">
              <p className="text-sm leading-6 text-accent-900">
                注意：真实事件并非线性推进，阶段常相互穿插。用时间线是帮助建立框架，而非机械套用模板。
              </p>
            </div>
          </div>

          <ol className="relative flex flex-col">
            {timelineSteps.map((step, idx) => (
              <li key={step.index} className="relative flex gap-5 pb-8 last:pb-0">
                {idx !== timelineSteps.length - 1 && (
                  <span className="absolute left-[27px] top-14 h-[calc(100%-40px)] w-px bg-background-300" />
                )}
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-background-300 bg-background-50">
                  <span className="font-heading text-sm font-bold text-primary-500">{step.index}</span>
                </div>
                <div className="flex-1 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                      {step.phase}
                    </span>
                    <h3 className="font-heading text-lg font-semibold text-foreground-950">{step.title}</h3>
                  </div>
                  <p className="mt-2 text-sm leading-7 text-foreground-600">{step.desc}</p>
                  <p className="mt-3 border-t border-dashed border-background-200 pt-2.5 text-xs text-primary-700">
                    核心要点：{step.point}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}